<template>
  <div v-if="tabShow">
    <div class="title-heading" style="margin-left: 35px">
      <!-- <TitleTag>
        <span slot="title" style="font-size:18px;font-weight:800;">{{titlePage}}</span>
      </TitleTag> -->
      <p>
        <i style="position: relative; top: 5px;margin-right: 5px;">
          <img src="@/assets/titleBlock/heading1.png" alt="">
        </i>
        {{ titlePage }}
        <i style="position: relative; top: 5px;margin-left: 5px;">
          <img src="@/assets/titleBlock/heading2.png" alt="">
        </i>
      </p>
    </div>

    <!-- <div :class="{ active: ColPage, active2: !ColPage }" v-for="item in columnInfo" :key="item.id" :model="pageData"> -->
    <div class="active2" v-for="item in columnInfo" :key="item.id" :model="pageData">
      <div>

        <div>
          <el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 1">
            <el-input maxlength="300" :style="input_width" v-model="pageData[item.index]"
              :disabled="!item.editable || !tableWritable" @input="upInput(item.index)"
              @blur='emitInput(item.index)'></el-input>
          </el-form-item>
        </div>
      </div>

      <div>
        <el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 2">
          <el-input maxlength="4000" show-word-limit type="textarea" :style="input_width"
            :disabled="!item.editable || !tableWritable" v-model="pageData[item.index]" @input="upInput(item.index)"
            @blur='emitInput(item.index)'>
          </el-input>
        </el-form-item>
      </div>

      <div>
        <el-form-item :label="item.name + ':'" v-if="item.uiType == 3" :required="item.required">
          <el-cascader clearable v-if="item.listType == 2" :style="input_width" v-model="pageData[item.index]"
            :options="item.listEntrie" :show-all-levels="false" :props="{ checkStrictly: true }"
            @change="upCascadeList(item.index)">
          </el-cascader>
          <el-select v-else v-model="pageData[item.index]" clearable filterable
            :placeholder="$t('message.placeholder.select')" :style="input_width"
            :disabled="!item.editable || !tableWritable" @change="upSimpleList(item.index)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.id">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div>
        <el-form-item :label="item.name + ':'" v-if="item.uiType == 4" :required="item.required">
          <el-cascader v-if="item.listType == 2" :style="input_width" v-model="casMultiData[item.index]"
            :options="item.listEntrie" :props="multi" :show-all-levels="false" @change="upCascadeMultiList(item.index)">
          </el-cascader>
          <el-select v-else v-model="pageData[item.index]" :placeholder="$t('message.placeholder.select')"
            :style="input_width" :disabled="!item.editable || !tableWritable" multiple filterable
            @change="upMultiList(item.index)">
            <el-option :label="items.name" :value="items.id" v-for="items in item.listEntrie" :key="items.index">
            </el-option>
          </el-select>
        </el-form-item>
      </div>

      <div>
        <el-form-item :label="item.name + ':'" v-if="item.uiType == 6" :required="item.required">
          <el-date-picker v-if="item.id == 1051001" @change="upDateTime(item.index, item.id)" :style="input_width"
            v-model="pageData[item.index]" type="date" :picker-options="pickerOptionsStart"
            :placeholder="$t('message.placeholder.pickDate')" :disabled="!item.editable">
          </el-date-picker>
          <el-date-picker v-else-if="item.id == 1051002" @change="upDateTime(item.index, item.id)" :style="input_width"
            v-model="pageData[item.index]" type="date" :picker-options="pickerOptionsEnd"
            :placeholder="$t('message.placeholder.pickDate')" :disabled="!item.editable">
          </el-date-picker>
          <el-date-picker v-else-if="item.id == 1051004" @change="upDateTimeACT(item.index, item.id)"
            :style="input_width" v-model="pageData[item.index]" type="date" :picker-options="pickerOptionsStartACT"
            :placeholder="$t('message.placeholder.pickDate')" :disabled="!item.editable">
          </el-date-picker>
          <el-date-picker v-else-if="item.id == 1051005" @change="upDateTimeACT(item.index, item.id)"
            :style="input_width" v-model="pageData[item.index]" type="date" :picker-options="pickerOptionsEndACT"
            :placeholder="$t('message.placeholder.pickDate')" :disabled="!item.editable">
          </el-date-picker>
          <el-date-picker v-else @change="upDateNormallTime(item.index)" :style="input_width"
            v-model="pageData[item.index]" type="date" :placeholder="$t('message.placeholder.pickDate')"
            :disabled="!item.editable || !tableWritable">
          </el-date-picker>

        </el-form-item>
      </div>

      <div>
        <el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 7">
          <!-- <el-input :style="input_width" :disabled="item.required"></el-input> -->
          <el-input v-if="item.id == 1051003" maxlength="240" :style="input_width" v-model="duration"
            :disabled="!item.editable || !tableWritable" type="integer" min="1"
            @input="editDateVal(item.index, item.id)" @blur='emitDateVal(item.index, item.id)'>
          </el-input>
          <el-input v-else :style="input_width" v-model="pageData[item.index]" @input="upNumberInput(item.index)"
            @blur='emitInput(item.index)' :disabled="!item.editable || !tableWritable"></el-input>
        </el-form-item>
      </div>

      <div class="moneyUi">
        <el-form-item :label="item.name + ':'" :required="item.required" v-if="item.uiType == 10">
          <el-input :style="input_width" v-model="pageData[item.index]" @input='costInput(item.index)'
            @blur="upCurrency(item.index)" :readonly='item.id == 1051046 || item.id == 1051047'
            :disabled="!item.editable || !tableWritable">
            <!-- <span style="margin:0 5px" slot="prefix" >{{"￥ " + " "}} </span> -->
            <span style="margin:0 5px" slot="append">{{ "￥ " + "人民币" }} </span>
            <!-- <el-select
              v-model="currencyIdList[item.index]"
              slot="append"
              :placeholder="$t('message.placeholder.select')"
              @change="upCurrencyId(item.index)"
              disabled="true"
              style="width:25px"
            >
              <el-option
                :label="items.name"
                :value="items.id"
                v-for="items in item.listEntrie"
                :key="items.id"
              ></el-option>
            </el-select> -->
          </el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTag from "@/components/titleTag";
export default {
  data() {
    return {
      titleName: "",
      tabShow: true,
      pageInfo: {},
      columnInfo: [],
      column: [],
      titlePage: "",
      ColPage: "false",
      isClearable: true,
      searchMf: "",
      dateList: [],
      list: [],
      casMultiData: [],
      duration: '',
      tableWritable: true,

      pickerOptionsStart: {
        disabledDate: (time) => {
          const endTimeIndex = this.columnInfo.find(i => i.id == 1051002).index
          return time.getTime() > Date.parse(this.pageData[[endTimeIndex]]);
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)

      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.columnInfo.some(i => i.id == 1051001)) {
            const startTimeIndex = this.columnInfo.find(i => i.id == 1051001).index
            return time.getTime() < Date.parse(this.pageData[[startTimeIndex]]) - 24 * 60 * 60 * 1000
          }

        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      },

      pickerOptionsStartACT: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      },

      pickerOptionsEndACT: {
        disabledDate: (time) => {
          const startTimeIndexACT = this.columnInfo.find(i => i.id == 1051004).index;
          if (Date.parse(this.pageData[[startTimeIndexACT]])) {
            return time.getTime() < Date.parse(this.pageData[[startTimeIndexACT]]) - 24 * 60 * 60 * 1000;
          } else {
            return true;
          }
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      },

      budgetedCosts: [],
      actualCosts: [],
      currencyIdList: [],

      pageData: [],
      input_width: {
        width: "70%",
      },
      multiList: [],
      cascadeList: [],
      cascadeMultiList: [],
      multi: { multiple: true },
      resetNum: "",
      pageOrder: [
        this.$t("message.title.pageOne"),
        this.$t("message.title.pageTwo"),
        this.$t("message.title.pageThree"),
      ],
      // baseId: "",
      basicData: {},
      subData: {},
      moneyUiData: {},
      isReq: true,
    };
  },
  components: {
    TitleTag,
  },
  props: ["page", "pageIndex", "reset", "editNum"],
  methods: {
    getColumn() {
      // // console.log('eeeeeeee',this.page);
      if (this.page.column.ids.length == 0) {
        this.columnInfo = [];
        this.tabShow = false;
        return;
      }
      this.budgetedCosts = [];
      this.actualCosts = [];
      // // console.log(this.page.val);
      let valArr = this.deepCopy(this.page.val);
      let n = valArr.cells;
      // // console.log(valArr);
      // this.baseId = parseInt(valArr.objClass.toString().substr(0, 3));
      let column = this.getNewData(this.page.column);

      console.log(column);
      const targetIds = new Set(["1051010", "1051011", "1051020"]);
      column.forEach(item => {
        const idAsString = String(item.id);
        if (targetIds.has(idAsString)) {
          item.listType = 1;
        }
      });

      column.map((i) => (i.id = i.id + ""));
      column.map((i, e) => (i.index = e));

      const arr = valArr.cells;

      const simpleUiType = [1, 2, 6, 7, 8, 10];
      const speSipList = [1051009];
      const speMultiList = [1090016, 1092005];
      const costList = [1051036, 1051037, 1051038, 1051039, 1051040, 1051041, 1051042, 1051043, 1051044, 1051045, 1051046, 1051047];

      column.map((i, e) => {
        if (simpleUiType.includes(i.uiType)) {
          // // console.log(e,arr[e].val);
          this.pageData[i.index] =
            JSON.stringify(arr[e].val) == "{}" ? "" : arr[e].val;
        }

        if (i.id == 1051003) {
          this.duration = arr[e].val
        }

        if (i.uiType == 3) {
          if (speSipList.includes(parseInt(i.id))) {
            // // console.log(arr[e]);
            i.listEntrie = [{ name: arr[e].val, id: arr[e].id }];
          }
          if ([1051010, 1051011, 1051071, 1001241].includes(parseInt(i.id))) {
            i.listEntrie = this.page.userList.map((i) => {
              return { name: i.displayUserName, id: i.id + '' };
            });
          }
          // if (i.id == 1051030) {
          //   i.listEntrie = this.page.column.workflowList;
          // }

          this.pageData[i.index] = arr[e].id == -1 ? "" : arr[e].id;
          if (i.listType == 2) {
            this.cascadeList.push(parseInt(i.id));
            // // console.log(this.cascadeList);
            if (arr[e].id != -1) {
              this.pageData[i.index] = this.getParentIdList(
                i.listEntrie,
                parseInt(arr[e].id)
              );
            }
          }
          // // console.log(i.id,i.listEntrie);
          // // console.log( this.pageData[i.index]);
        }
        if (i.uiType == 4) {
          if (speMultiList.includes(parseInt(i.id))) {
            i.editable = false;
          }
          if ([1051010, 1051020, 1051011].includes(parseInt(i.id))) {
            console.log(this.page);
            i.listEntrie = this.page.userList.map((i) => {
              return { name: i.displayUserName, id: (i.id + '') };
            });
          }
          if (i.listType == 2) {
            this.cascadeMultiList.push(parseInt(i.id));
            let m = arr[e].ids;
            this.pageData[i.index] = m
              ? m.split(";").map((j) => {
                return this.getParentIdList(i.listEntrie, parseInt(j));
              })
              : "";
            this.casMultiData[i.index] = this.pageData[i.index];
          }
          if (i.listType == 1 || !i.listType) {
            this.multiList.push(parseInt(i.id));
            let m = arr[e].ids;
            this.pageData[i.index] = m
              ? m.split(";").map((i) => {
                if (i) {
                  return (i + '');
                }
              })
              : "";
          }
        }

        if (i.uiType == 10) {
          // // console.log(i);
          this.pageData[i.index] = arr[e].realVal;
          this.currencyIdList[i.index] = JSON.stringify(arr[e].currencyCode) == "{}" ? '' : arr[e].currencyCode + ''
          i.val = arr[e];
          costList.filter((_, e) => (e % 2)).includes(parseInt(i.id)) && this.budgetedCosts.push(i.index);
          costList.filter((_, e) => !(e % 2)).includes(parseInt(i.id)) && this.actualCosts.push(i.index);
          // console.log(this.currencyIdList[i.index]);
        }

      });

      column.map((i) => {
        return (this.basicData[i.id] = this.pageData[i.index]);
      });
      this.columnInfo = column;

      let list = this.columnInfo.filter((i) => i.required).map((i) => i.id);
      // // console.log(list);
      let m = this.basicData;
      // // console.log(m);
      for (const key in list) {
        let e = list[key];
        if (!m[e] || JSON.stringify(m[e]) == "[]") {
          // // console.log(e,m[e]);
          this.isReq = false;
        }
      }
      // // console.log(this.isReq);

      !this.pageIndex && this.columnInfo.map((i, e) => (i.editable = n[e].editable));
      this.$emit("update:checkReq", this.isReq);

    },

    upInput() {

      this.$forceUpdate();
      this.$emit("hasChanged");
    },

    editDateVal(i, e) {
      this.$forceUpdate();
      this.duration = Number(this.duration.substr(0, 6).replace(/[^0-9]/g, '')) || '';

    },
    emitDateVal() {
      const st = this.columnInfo.find((i) => i.id == 1051001).index;
      const et = this.columnInfo.find((i) => i.id == 1051002).index;

      if (this.duration) {
        if (this.pageData[st] || this.pageData[et]) {
          let day = !this.pageData[st] ? this.countStartDate(this.duration, this.pageData[et]) : this.countEndDate(this.duration, this.pageData[st]);
          const tempId = !this.pageData[st] ? 1051001 : 1051002;
          const tempIndex = !this.pageData[st] ? st : et;
          this.$set(this.pageData, tempIndex, day)
          this.$set(this.subData, tempId, day)
        }
      }
      this.subData["1051003"] = this.duration * 8 * 60 * 60 * 1000 || '';
      this.upData();
    },
    emitInput(i, id) {
      const m = id || this.columnInfo.find((item) => item.index == i).id;
      let n = this.pageData[i];
      // console.log(n);
      const arr = [1051061, 1051062, 1051063,]
      this.subData[m] = !n ? '' : n.trim();
      if (arr.includes(parseInt(m))) {
        this.subData[m] = n * 8 * 60 * 60 * 1000
      }
      this.upData();
    },
    upNumberInput(i) {
      const m = this.columnInfo.find((item) => item.index == i).id;

      this.pageData[i] = this.pageData[i].replace(/[^0-9.]/g, '')
      this.$forceUpdate();
      this.$emit("hasChanged");
    },
    costInput(i) {
      // // console.log(i);
      let costConvolution = (arr) => {
        let sum = 0;
        for (let i = 0, j = arr.length - 1; i < j; i++) {
          sum += parseInt(this.pageData[arr[i]]) || 0;
        }
        this.pageData[arr[arr.length - 1]] = sum;
      };
      this.budgetedCosts.includes(i) && costConvolution(this.budgetedCosts)
      this.actualCosts.includes(i) && costConvolution(this.actualCosts)

      // this.pageData[i]=this.pageData[i].replace(/[^0-9.]/g,'');
      let n = this.pageData[i];
      this.pageData[i] = n.replace(/[^0-9.]/g, '');
      if (!Number(n)) {
        this.pageData[i] = '';
      }

      this.$forceUpdate();
      this.emitInput(i);
      // this.emitInput()
      this.$emit("hasChanged");
    },
    upCurrency(i) {
      let n = parseFloat(this.pageData[i]).toFixed(2);
      n = isNaN(n) ? '' : n
      const m = this.columnInfo.find(item => item.index == i).id;
      this.$set(this.pageData, i, n)
      this.subData[m] = n;
      // if (!this.currencyIdList[i]) {
      //   const currencyId = m + '_01';
      //   const defaultCurrency = this.columnInfo.find(item =>item.index == i).listEntrie[0].id;
      //   // this.currencyIdList[i] = defaultCurrency;
      //   this.subData[currencyId] =  defaultCurrency;
      // }
      this.upData()
    },

    pickTime(i) {
      let m = this.columnInfo.find((item) => item.index == i).id;
      m == 1051002 && this.pickerOptions(m);
    },

    upDateTimeACT(i, id) {
      if (id == 1051004) {
        const ACTIndex = this.columnInfo.find(i => i.id == 1051005).index;
        this.pageData[ACTIndex] = "";
        this.subData[1051005] = null;
      }
      let t = this.pageData[i];
      if (t) {
        this.pageData[i] = new Date(Date.parse(t) - t.getTimezoneOffset() * 60 * 1000);
      }
      this.subData[id] = this.pageData[i];
      this.$emit("hasChanged");
      this.upData();
    },

    upDateTime(i, id) {
      let t = this.pageData[i];
      const st = this.columnInfo.find((i) => i.id == 1051001).index;
      const et = this.columnInfo.find((i) => i.id == 1051002).index;
      const tempId = id == 1051001 ? 1051002 : 1051001;
      const tempIndex = i == st ? et : st;

      if (t) {
        this.pageData[i] = new Date(Date.parse(t) + -t.getTimezoneOffset() * 60 * 1000);
        if (st == i && this.pageData[i] > this.pageData[et]) {
          this.$set(this.pageData, et, '');
        }
        if (et == i && this.pageData[i] < this.pageData[st]) {
          this.$set(this.pageData, st, '')
        }

        if (this.duration) {
          let day = id == 1051001 ? this.countEndDate(this.duration, this.pageData[i]) : this.countStartDate(this.duration, this.pageData[i]);
          this.$set(this.pageData, tempIndex, day)
          this.$set(this.subData, tempId, day)
        } else {
          if (!this.pageData[tempIndex]) {
            this.subData[id] = '';
            this.duration = '';
            this.subData['1051003'] = '';
          } else {
            let n = this.countWorkDay(this.pageData[st], this.pageData[et])
            this.duration = n;
            this.subData['1051003'] = n * 8 * 60 * 60 * 1000;
          }
        }
      }
      this.subData[id] = this.pageData[i];
      this.$emit("hasChanged");
      this.upData();
    },
    upDateNormallTime(i) {
      this.$emit("hasChanged");
      let t = this.pageData[i];
      let m = this.columnInfo.find((item) => item.index == i).id;
      if ((m == 1051004 || m == 1051005) && !!t) {
        this.pageData[i] = new Date(Date.parse(t) + -t.getTimezoneOffset() * 60 * 1000)
      }
      this.subData[m] = this.pageData[i] || '';
      this.$forceUpdate();
      this.upData();
    },
    upCascadeList(i) {
      this.$forceUpdate();
      console.log(this.pageData[i]);
      let n = this.pageData[i];
      let m = this.columnInfo.find((item) => item.index == i).id;
      this.subData[m] = n[n.length - 1] || "";
      console.log(n, this.subData[m]);
      this.upData();
    },

    upSimpleList(i) {
      this.$forceUpdate();
      let n = this.pageData[i];
      let m = this.columnInfo.find((item) => item.index == i).id;
      this.subData[m] = n || "";
      this.upData();
    },
    upMultiList(i) {
      this.$forceUpdate();
      let n = this.pageData[i];
      let m = this.columnInfo.find((item) => item.index == i).id;
      this.subData[m] = this.arrSort(n);
      this.upData();
    },
    upCascadeMultiList(i) {
      // // console.log(this.casMultiData[i]);
      // // console.log(this.pageData[i]);
      let n = this.deepCopy(this.casMultiData[i]);
      let m = this.columnInfo.find((item) => item.index == i).id;
      this.subData[m] = n.length > 0 ? this.arrSort(n.map(this.arrLast)) : "";
      this.upData();
    },
    arrLast(n) {
      n = n.length > 0 ? n[n.length - 1] : "";
      return n;
    },
    arrSort(n) {
      n = n.length > 0 ? n.sort((a, b) => a - b).join(";") : "";
      return n;
    },


    upCurrencyId(i) {
      const currencyId = this.columnInfo.find(item => item.index == i).val.currencyId;
      this.subData[currencyId] = this.currencyIdList[i];
      this.$forceUpdate();
      this.upData();
    },
    upData() {
      this.$emit("update:change", this.subData);
      this.$emit("hasChanged");
      // // console.log(this.subData);

      let arr = this.columnInfo.filter((i) => i.required).map((i) => i.id);
      let m = Object.assign(this.basicData, this.subData);
      for (const key in arr) {
        let e = arr[key];
        if (!Boolean(m[e])) {
          this.isReq = false;
          break;
        } else {
          this.isReq = true;
        }
      }
      // console.log(this.isReq);
      this.$emit("update:checkReq", this.isReq);
    },
    getCalendar() {
      this.$http.get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear()).then(
        res => {
          console.log(res);
          this.calendarList = res.data.object;
          this.cList = this.calendarList.map(i => i.exceptionDate.split('T')[0]);
        }
      )
    },

    calendarDate(time) {
      if (this.cList.includes(this.getLocalTime(time.getTime()))) {
        if ([0, 6].includes(time.getDay())) {
          return 'date-pick-workday'
        } else {
          return 'date-pick-holiday'
        }
      }
      if ([0, 6].includes(time.getDay()) && !this.cList.includes(this.getLocalTime(time.getTime()))) {
        return 'date-pick-holiday'
      }
    },
    //通过获取当前的租户来判断实际开始/结束时间的选择范围
    //如果是租户为tianbian则通过setupPickerOptionsACT修改两个实际时间只能选择为当天
    getTenantName() {
      let systemName;
      try {
        systemName = window.sessionStorage.getItem("systemName");
      } catch (error) {
        console.error('Error parsing sessionStorage data:', error);
        systemName = '';
      }
      if (systemName === "tianbian") {
        this.setupPickerOptionsACT();
      }
    },
    setupPickerOptionsACT() {
      this.pickerOptionsStartACT = {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          return time.getTime() < today.getTime() || time.getTime() >= tomorrow.getTime();
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      };
      this.pickerOptionsEndACT = {
        disabledDate: (time) => {
          const startTimeIndexACT = this.columnInfo.find(i => i.id == 1051004).index;
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          if (Date.parse(this.pageData[[startTimeIndexACT]])) {
            return time.getTime() < today.getTime() || time.getTime() >= tomorrow.getTime();
          } else {
            return true;
          }
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time)
      };
    }
  },
  mounted() {
    this.titlePage = this.pageOrder[this.pageIndex];
    // console.log(this.pageIndex);

  },
  created() {
    this.getColumn();
    this.subData = {};
    !this.pageIndex && this.getCalendar();

    if (this.pageIndex) {
      this.tableWritable = this.page.tableWritable;
    }
    this.getTenantName();
  },
  updated() {
    // // console.log(this.budgetedCosts);
    // // console.log(this.costConvolution);
  },
  computed: {},
  watch: {
    editNum(e) {
      if (e % 2) {
        this.getColumn();
      } else {
        this.pageData = [];
        this.subData = {};
      }
    },
  },
};
</script>

<style>
ol,
ul {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}

.date-pick-workday span {
  /* color: #fff; */
  /* background: #f56c6c; */
  border-radius: 12px;
}

.date-pick-holiday span {
  /* color: #fff; */
  background: #a0cfff;
  border-radius: 8% !important;
}
</style>

<style scoped>
.active {
  width: 48%;
  display: block;
  /* float: left; */
}

.active2 {
  text-align: left;
  width: 40%;
  /* display: block; */
  float: left;
}

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 18px 0;
}

.heading p {
  font-size: 18px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 18px -20px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}
</style>
